"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React from "react";
import { Observer, observer } from "mobx-react";
import { Tick } from "../../../icons";
import { DropdownContext } from "../Dropdown/DropdownContext";
import { DropdownTheme } from "../Dropdown/DropdownTheme";
var DropdownItem = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownItem, _React$Component);
  var _super = _createSuper(DropdownItem);
  function DropdownItem() {
    _classCallCheck(this, DropdownItem);
    return _super.apply(this, arguments);
  }
  _createClass(DropdownItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        selected = _this$props.selected,
        onSelect = _this$props.onSelect,
        disable = _this$props.disable;
      return /* @__PURE__ */React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var theme = _ref.theme;
        return /* @__PURE__ */React.createElement(Observer, null, function () {
          return /* @__PURE__ */React.createElement("div", {
            className: classNames({
              "dropdown-item": true,
              "space-between": true,
              "dropdown-item--disable": disable,
              "dropdown-item--dark": theme === DropdownTheme.Dark
            }),
            onClick: onSelect
          }, /* @__PURE__ */React.createElement("span", {
            className: classNames({
              "dropdown-item__name": true,
              "dropdown-item__name--disable": disable
            })
          }, name), selected && /* @__PURE__ */React.createElement(Tick, {
            className: classNames({
              "dropdown-item__tick": true,
              "dropdown-item__tick--disable": disable
            })
          }));
        });
      });
    }
  }]);
  return DropdownItem;
}(React.Component);
DropdownItem = __decorateClass([observer], DropdownItem);
export { DropdownItem as default };